import { ServiceModuleApiInterface, ServiceModuleServiceInterface } from '@src/server';
import { MapperInterface } from '@src/server/converters/types/mapper.interface';
import { ServiceModuleInterface } from '@src/domain/types';
import { ServiceModulesApi } from 'cmp-client-api';

export class ServiceModuleService implements ServiceModuleServiceInterface {
  private readonly service: ServiceModulesApi;

  private readonly serviceMapper: MapperInterface<
    ServiceModuleInterface[],
    ServiceModuleApiInterface[]
  >;

  public constructor(
    service: ServiceModulesApi,
    serviceMapper: MapperInterface<ServiceModuleInterface[], ServiceModuleApiInterface[]>
  ) {
    this.service = service;
    this.serviceMapper = serviceMapper;
  }

  public getList(page?: number, size?: number): Promise<ServiceModuleInterface[]> {
    return this.service
      .getServiceModules(page, size)
      .then(({ data }) => data)
      .then(({ data }) => data)
      .then(this.serviceMapper.transformFromApiModel);
  }
}
